import { useQuery } from '@tanstack/react-query';
import { getPublicTenantConfig } from './api';
import { DEFAULT_COIN_LABEL } from './coin-label';

/**
 * The tenant's coin display name (e.g. "UPCoin"), for every till surface that
 * names the coin wallet.
 *
 * Reads the public `/tenant/config` endpoint, cached for a minute and shared by
 * every caller through the one react-query key. Falls back to "Coins" while
 * loading and if the call fails, which keeps the till usable when branding is
 * unreachable.
 */
export function useCoinLabel(): string {
  const q = useQuery({
    queryKey: ['public-tenant-config'],
    queryFn: getPublicTenantConfig,
    staleTime: 60_000,
    retry: false,
  });
  return q.data?.coinLabel || DEFAULT_COIN_LABEL;
}
